const LAUNCH_PRODUCT_CODE_KEY = 'launch.productCode';
const LAUNCH_GRADE_CODE_KEY = 'launch.gradeCode';

// Capture the launch product-grade (?productCode&gradeCode) at startup, before lst-auth's
// SSO redirect drops the query params. Read back by the requireProgramResolved guard.
// Realize launches with lowercase `productcode`/`gradecode`; the dev/standalone links use
// camelCase. Match on a case-insensitive key so both land.
function getParam(params: URLSearchParams, name: string): string | null {
  const wanted = name.toLowerCase();
  for (const [key, value] of params) {
    if (key.toLowerCase() === wanted) return value;
  }
  return null;
}

export function captureLaunchParams(): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const productCode = getParam(params, 'productCode');
  if (productCode) {
    sessionStorage.setItem(LAUNCH_PRODUCT_CODE_KEY, productCode);
    sessionStorage.setItem(LAUNCH_GRADE_CODE_KEY, getParam(params, 'gradeCode') ?? '');
  }
}

export function launchProductGrade(): { productCode: string | null; gradeCode: string } {
  if (typeof sessionStorage === 'undefined') return { productCode: null, gradeCode: '' };
  return {
    productCode: sessionStorage.getItem(LAUNCH_PRODUCT_CODE_KEY),
    gradeCode: sessionStorage.getItem(LAUNCH_GRADE_CODE_KEY) ?? '',
  };
}
